import { Col, FormGroup, Row } from 'reactstrap';
import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@s20/services/httpClient';
import { Block } from '../common/Block';
import { FlexStartRow, FormLabel, SubHeading } from '../common/forms/FormElements';
import { ApiRoutes } from '../Common';

export const EmployeeMetrics = ({ employeeId, metrics }) => {
    const { data: loadedData } = useQuery({
        queryKey: ['employeeMetrics', employeeId],
        queryFn: () => httpClient.js(ApiRoutes.employee.metrics(employeeId)),
        enabled: !metrics,
    });

    const data = loadedData || metrics || {};

    return (
        <Row className="m-0 employee-metrics">
            <Col
                xs={12}
                md={6}
            >
                <SubHeading>
                    Jobs
                </SubHeading>

                <Block className="details-block">
                    <FormGroup>
                        <FormLabel
                            label="Total Jobs"
                            className="bottom-border"
                        />

                        <FlexStartRow>
                            <span>
                                {data?.totalJobs || '-'}
                            </span>
                        </FlexStartRow>
                    </FormGroup>

                    {Boolean(data?.averageRating) && (
                        <FormGroup>
                            <FormLabel
                                label="Avg. Rating"
                                className="bottom-border"
                            />

                            <FlexStartRow>
                                <span>
                                    {data.averageRating}
                                </span>
                            </FlexStartRow>
                        </FormGroup>
                    )}

                    <FormGroup>
                        <FormLabel
                            label="# Crew Lead"
                            className="bottom-border"
                        />

                        <FlexStartRow>
                            <span>
                                {data?.totalCrewLead || '-'}
                            </span>
                        </FlexStartRow>
                    </FormGroup>
                </Block>


            </Col>

            <Col
                xs={12}
                md={6}
            >
                <SubHeading>
                    Attendance
                </SubHeading>

                <Block className="details-block">
                    <FormGroup>
                        <FormLabel
                            label="Late Arrivals"
                            className="bottom-border"
                        />

                        <FlexStartRow>
                            <span>
                                {data?.lateArrivals} ({data?.lateArrivalsPerJob}/job)
                            </span>
                        </FlexStartRow>
                    </FormGroup>

                    <FormGroup>
                        <FormLabel
                            label="Late Starts"
                            className="bottom-border"
                        />

                        <FlexStartRow>
                            <span>
                                {data?.lateStarts} ({data?.lateStartsPerJob}/job)
                            </span>
                        </FlexStartRow>
                    </FormGroup>

                    <FormGroup>
                        <FormLabel
                            label="No Calls/No Shows"
                            className="bottom-border"
                        />

                        <FlexStartRow>
                            <span>
                                {data?.ncns} ({data?.ncnsPerJob}/job)
                            </span>
                        </FlexStartRow>
                    </FormGroup>

                    <FormGroup>
                        <FormLabel
                            label="Refusals"
                            className="bottom-border"
                        />

                        <FlexStartRow>
                            <span>
                                {data?.refusals} ({data?.refusalsPerJob}/job)
                            </span>
                        </FlexStartRow>
                    </FormGroup>

                    <FormGroup>
                        <FormLabel
                            label="Call Offs"
                            className="bottom-border"
                        />

                        <FlexStartRow>
                            <span>
                                {data?.callOffs} ({data?.callOffsPerJob}/job)
                            </span>
                        </FlexStartRow>
                    </FormGroup>
                </Block>
            </Col>
        </Row>

    );
};